const VERSION: string = '0.1.7-prod.101'
export default VERSION;
